export enum UserTranslKey {
    CONTACT_DETAILS = "user:contactDetails",
    EMAIL = "user:email",
    FIRST_NAME = "user:firstName",
    DATABOX = "user:databox",
    LAST_NAME = "user:lastName",
    LOGIN = "user:login",
    LOGOUT = "user:logout",
    OTHERS = "user:others",
    PHONE = "user:phone",
    PROFILE = "user:profile",
    ROB_SUBSCRIPTION_STATUS = "user:robSubscriptionStatus",
    UPDATED_AT_IN_ROB = "user:updatedAtInRob",
    USER_DETAIL = "user:userDetail",
    USER_IDENTITY_SOURCE = "user:userIdentitySource",
    USER_OVERVIEW = "user:usersOverview",
    USER_PROFILE_TITLE = "user:profileTitle",
    VALID_FROM = "user:validFrom",
    VALID_TO = "user:validTo",
    VALIDITY = "user:validity",
}
